import { AuthenticationResponse } from "interface/user";
import { AxiosApi } from "./index"
import { AxiosError} from 'axios';
import { VerificationType } from "interface/common";

export interface ChangePasswordForm {
    oldPassword: string;
    newPassword: string;
    confirmPassword?: string;
    userName: string;
}


export const loginApi = async (email: string, password: string, rememberMe: boolean) => {
    try {
        const response = await AxiosApi.post("auth/login", { email, password, rememberMe })
        return response.data
    } catch (error : any) {
        const err : AxiosError  = error
        console.log(err)
        throw err.response
    }
}

export const signupApi = async (email: string, password: string, roles: string[]) => {
    try {
        const response = await AxiosApi.post("auth/signup", { email, password, roles })
        return response.data
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
}

export const requestTwoFactorAuthenticationCodeApi = async (email: string) => {
    try {
        const response = await AxiosApi.post("auth/2fa-request", { email, channel: "Phone" })
        return response
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
}

export const twoFactorAuthenticationApi = async (email: string, token: string) => {
    try {
        const response = await AxiosApi.post("auth/2fa", { email, token })
        return response
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
}

export const forgotPasswordApi = async (email: string) => {
    try {
        const response = await AxiosApi.post("auth/ForgotPassword", { email })
        return response
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
} 

export const resetPasswordApi = async (email: string, token: string, password: string) => {
    try {
        const response = await AxiosApi.post("auth/ResetPassword", { email, token, password })
        return response
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
} 

export const changePasswordApi = async (form :ChangePasswordForm ) => {
    try {
        const response = await AxiosApi.post("auth/ChangePassword", form )
        return response.data
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response?.data
    }
} 

export const adminChangePasswordApi = async (form :{userId: string, password: string} ) => {
    try {
        const response = await AxiosApi.post("auth/AdminChangePassword", form )
        return response.data
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response?.data
    }
} 

export const logoutApi = async () => {
    try {
        const response = await AxiosApi.post("auth/Logout", {})
        return response
    } catch (error: any) {
        const err: AxiosError = error
        throw err.response
    }
} 

export const cookieAuthApi = async () => {
    try {
        const response = await AxiosApi.get<AuthenticationResponse>("auth/Cookie")
        return response.data
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
} 

export const userVerificationApi = async ({ token, userId, verificationType}:{userId : string, token: string, verificationType: VerificationType}) => {
    try {
        const response = await AxiosApi.post<AuthenticationResponse>("auth/email_verification", {
            token, userId, verificationType
        })
        return response.data
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
} 

export const changePhoneNumberApi = async ({phoneNumber, prefix}:{phoneNumber: string, prefix: string}) => {
    try {
        const response = await AxiosApi.post("auth/ChangePhoneNumber", { phoneNumber, prefix })
        return response
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
}

export const changePhoneNumberVerificationApi = async ({phoneNumber, prefix, token}:{phoneNumber: string, prefix: string, token: string}) => {
    try {
        const response = await AxiosApi.post("auth/ChangePhoneNumberVerification", { phoneNumber, prefix, token })
        return response
    } catch (error : any) {
        const err : AxiosError  = error
        throw err.response
    }
}

export const signGdprApi = async () => {
    try {
        const response = await AxiosApi.post("auth/SignGdpr", {})
        return response.data
    } catch (error: any) {
        const err: AxiosError = error
        throw err.response
    }
}